import { NgtUniversalModule } from "@ng-toolkit/universal";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AdsenseModule } from "ng2-adsense";

// other
import { Ng5SliderModule } from "ng5-slider";

// routing
import { routing } from "./app.routing";

// services
import { DataService, PlayerService } from "../_services/index";

// components
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { CategoryComponent } from "./category/category.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { PlayerComponent } from "./player/player.component";
import { StationComponent } from "./station/station.component";
import { PageComponent } from "./page/page.component";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CategoryComponent,
    HeaderComponent,
    FooterComponent,
    PlayerComponent,
    StationComponent,
    PageComponent
  ],
  imports: [
    AdsenseModule.forRoot(),
    Ng5SliderModule,
    FormsModule,
    CommonModule,
    NgtUniversalModule,
    HttpClientModule,
    routing
  ],
  providers: [PlayerService, DataService]
})
export class AppModule {}
